import React, { useMemo } from 'react'
import { DataTableFiltersState, NestedDataTableState } from '../../../../shared/components/DataTable'
import { LinkedRecordsPanel } from '../../../../shared/components/LinkedRecordsPanel'
import useStrategicImperativeDisplayName from '../../../../shared/hooks/useDisplayNames/variants/useStrategicImperativeDisplayName'
import { useStrategicImperativesQuery } from '../../../../shared/queries/strategicImperatives'
import { getStrategicImperativeColumns } from '../StrategicImperativeTable.columns'
import {
    DEFAULT_LINKED_STRATEGIC_IMPERATIVE_COLUMN_IDS,
    getStrategicImperativePath,
} from '../StrategicImperativeTable.constants'
import {
    getStrategicImperativeFilterDefinitions,
    getStrategicImperativeSearchValues,
} from '../StrategicImperativeTable.filters'
import { StrategicImperativeColumnId } from '../StrategicImperativeTable.types'
import { useStrategicImperativeDisplayNames } from '../useStrategicImperativeDisplayNames'
import { renderStrategicImperativeCell } from './renderStrategicImperativeCell'

type LinkedStrategicImperativesPanelProps = {
    ownerName: string
    ownerLabel: string
    linkedIds: string[] | undefined
    filtersState: DataTableFiltersState
    state: NestedDataTableState<StrategicImperativeColumnId>
}

export const LinkedStrategicImperativesPanel = ({
    ownerName,
    ownerLabel,
    linkedIds,
    filtersState,
    state,
}: LinkedStrategicImperativesPanelProps) => {
    const strategicImperativeDisplayNames = useStrategicImperativeDisplayNames()
    const strategicImperativeDisplayName = useStrategicImperativeDisplayName()
    const strategicImperativesQuery = useStrategicImperativesQuery()
    const strategicImperatives = useMemo(() => strategicImperativesQuery.data ?? [], [strategicImperativesQuery.data])

    return (
        <LinkedRecordsPanel
            ownerName={ownerName}
            ownerLabel={ownerLabel}
            recordsQuery={strategicImperativesQuery}
            records={strategicImperatives}
            linkedIds={linkedIds}
            recordDisplayName={strategicImperativeDisplayName}
            columns={getStrategicImperativeColumns(strategicImperativeDisplayNames)}
            filterDefinitions={getStrategicImperativeFilterDefinitions(
                strategicImperativeDisplayNames,
                DEFAULT_LINKED_STRATEGIC_IMPERATIVE_COLUMN_IDS
            )}
            getSearchValues={getStrategicImperativeSearchValues}
            renderCell={renderStrategicImperativeCell()}
            getRecordName={(strategicImperative) => strategicImperative.name}
            getRecordPath={getStrategicImperativePath}
            filtersState={filtersState}
            state={state}
        />
    )
}

export default LinkedStrategicImperativesPanel
